module.exports = __webpack_public_path__ + "img/basic.ee50c721.svg";